import { authResource } from './Auth';
export const AccountPasswordResource = authResource({
    path: '/accounts/:accountId/password',
    schema: {}
}).extend((BaseResource) => ({
    forceChange: BaseResource.update.extend({
        path: '/accounts/:id/forcepasswordchange',
        method: 'POST',
        body: undefined,
        schema: undefined,
        process: (response) => {
            if (response !== 'Success') {
                throw new Error(response);
            }
            return undefined;
        }
    }),
    update: BaseResource.update.extend({
        body: {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: ''
        },
        schema: undefined,
        process: (response) => {
            if (response !== 'Password has been changed') {
                throw new Error(response);
            }
            return undefined;
        }
    })
}));
